<template>
  <div id="katalog-tiket">
    <ol class="breadcrumb pull-right">
      <li><router-link :to="{ path: '/' }">Home</router-link></li>
      <li>Menu</li>
      <li class="active">Menu</li>
    </ol>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">Menu</h1>
    <!-- end page-header -->
    <div class="row">
      <div class="col-md-12">
        <!-- begin panel -->
        <div class="panel panel-inverse">
          <div class="panel-heading">
            <div class="pull-right">
              <button
                type="button"
                class="btn btn-success btn-xs m-r-5"
                @click="createMenu()"
              >
                <span class="fa fa-plus"></span> Tambah Menu
              </button>
            </div>
            <h4 class="panel-title">List Menu</h4>
          </div>
          <div class="panel-body">
            <app-datatable
              :items="MenuList"
              :has-action="true"
              :has-custom-pagination="true"
              :has-custom-search="true"
              :has-publish="true"
              :has-edit-a="true"
              :custom-pagination-current-page="pagination.currentPage"
              :custom-pagination-per-page="10"
              :custom-pagination-total-pages="pagination.totalPages"
              :custom-pagination-sort-mode="pagination.sortMode"
              :headers="headers"
              v-on:selected="selectedRow = $event"
              v-on:dblClicked="updateMenu()"
              v-on:editNewTab="updateMenuBtn($event)"
              v-on:deleted="deleteMenu($event)"
              v-on:changePage="
                pagination = { ...pagination, currentPage: $event }
              "
              v-on:changeSortMode="
                pagination = { ...pagination, sortMode: $event }
              "
              v-on:doSearch="
                search = { query: $event.value, by: headersKey[$event.key] }
              "
            />
          </div>
        </div>
      </div>
    </div>
    <app-spinner v-if="isLoading"></app-spinner>
  </div>
</template>

<script>
import ContentService from "@/services/content.js";
import DataTable from "@/components/plugins/DataTable";
import Spinner from "@/components/plugins/Spinner";
import Moment from "moment";

export default {
  name: "katalog-tiket",
  components: {
    "app-datatable": DataTable,
    "app-spinner": Spinner,
  },
  data: function () {
    return {
      isLoading: false,
      MenuList: [],
      fullData: [],
      status: {
        PUBLISH: "PUBLISHED",
        UNPUBLISH: "UNPUBLISHED",
      },
      selectedRow: null,
      search: null,
      pagination: {
        perPage: 25,
        currentPage: 1,
        totalPages: 0,
        sortMode: "desc",
      },
      type: {
        // SCHEDULED_TRYOUT: 'SCHEDULED_TRYOUT',
        // INSTANT_TRYOUT: 'INSTANT_TRYOUT',
        // CONSULTATION: 'CONSULTATION',
        // DUEL: 'DUEL',
        // ITEM_BANK: 'ITEM_BANK',
        // VIDEO: 'VIDEO'
      },
      headers: ["Nama", "Judul", "Status"],
      headersKey: ["name", "description", "status"],
    };
  },
  mounted: function () {
    this.fetchData();
  },
  watch: {
    pagination: function () {
      this.fetchData();
    },
  },
  methods: {
    fetchData: function () {
      var context = this;
      var search = this.search;
      var pagination = {
        perPage: this.pagination.perPage,
        currentPage: this.pagination.currentPage,
        sortMode: this.pagination.sortMode,
      };

      this.isLoading = true;

      ContentService.getMenuList(pagination, search, function (result) {
        context.MenuList = [];
        context.isLoading = false;

        if (result.success) {
          if (pagination.currentPage > 1 && result.data.length < 1) {
            context.pagination.currentPage =
              parseInt(pagination.currentPage) - 1;
            alert(
              "Data hanya sampai halaman " + context.pagination.currentPage
            );
            context.fetchData();
          } else if (pagination.currentPage === 1 && result.data.length === 0) {
            alert("Maaf, data belum ada ");
          }
          result.data.forEach(function (content) {
            var row = {
              id: content.id,
              data: [content.name, content.description, content.status],
            };
            context.pagination.totalPages = content.total_page;
            context.MenuList.push(row);
            context.fullData.push(content);
          });
        } else {
          alert("Terjadi Kesalahan : " + result.data.message);
        }
      });
    },
    createMenu: function () {
      this.$router.push({ path: "/content/menu-form" });
    },
    updateMenu: function () {
      var selected = this.fullData.find((element) => {
        return element.id == this.selectedRow.id;
      });
      this.$store.commit("setEditDataContent", selected);
      this.$router.push({
        path: "/content/menu-form",
        query: { id: this.selectedRow.id },
      });
    },
    updateMenuBtn: function (value) {
      // console.log(value)
      var selected = this.fullData.find((element) => {
        return element.id == value.id;
      });
      this.$store.commit("setEditDataContent", selected);
      this.$router.push({
        path: "/content/menu-form",
        query: { id: value.id },
      });
    },
    deleteMenu: function (content) {
      var context = this;
      var contentID = content.id;
      var confirmed = window.confirm(
        "Apakah anda yakin akan menghapus Menu ini?"
      );
      if (confirmed) {
        this.isLoading = true;
        ContentService.deleteMenu(contentID, function (result) {
          context.isLoading = false;
          if (result.success) {
            alert("Data Terhapus");
            context.fetchData();
          } else {
            alert("Terjadi Kesalahan : " + result.message);
          }
        });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// Menu.vue?21cfda6f